<template>
  <app-layout>
    <template #header>
      <div class="flex justify-between">
        <div>
          <h2 class="font-semibold text-xl text-gray-800 leading-tight">
            Usuário
          </h2>
        </div>
        <div class="float-right">
          <inertia-link :href="route('user.index')">Lista</inertia-link>
        </div>
      </div>
    </template>
    <div>
      <div class="max-w-6xl mx-auto py-2 px-2">
        <div class="md:grid">
          <div>
            <div class="py-4">
              <span>Editar Usuário {{user.name}}</span>
            </div>
            <div class="mt-5 md:mt-0 md:col-span-2">
              <form @submit.prevent="save">
                <div class="shadow overflow-hidden sm:rounded-md">
                  <div class="px-4 py-5 bg-white">
                    <div class="grid grid-cols-12 py-2 gap-6">
                      <div class="col-span-12 sm:col-span-4">
                        <label class="block font-medium text-sm text-gray-700">
                          Nome
                        </label>
                        <el-input
                          class="mt-1 w-full"
                          v-model="form.name"
                        >
                        </el-input>
                        <jet-input-error
                          :message="form.errors.name"
                          class="mt-2"
                        />
                      </div>
                      <div class="col-span-12 sm:col-span-5">
                        <label class="block font-medium text-sm text-gray-700">
                          Email
                        </label>
                        <el-input
                          class="mt-1 w-full"
                          disabled
                          v-model="form.email"
                        >
                        </el-input>
                        <jet-input-error
                          :message="form.errors.email"
                          class="mt-2"
                        />
                      </div>
                      <div class="col-span-12 sm:col-span-2">
                        <label class="block font-medium text-sm text-gray-700">
                          Status
                        </label>
                        <el-select v-model="form.state">
                          <el-option
                            value="ATIVO"
                            label="Ativo"
                          ></el-option>
                          <el-option
                            value="BLOQUEADO"
                            label="Bloqueado"
                          ></el-option>
                        </el-select>
                        <jet-input-error
                          :message="form.errors.state"
                          class="mt-2"
                        />

                      </div>
                    </div>
                    <div class="grid grid-cols-12 py-2 gap-6">
                      <div class="col-span-12 sm:col-span-12">
                        <label class="block font-medium text-sm text-gray-700 mb-2">
                          Centros de custo
                        </label>
                        <check-group
                          id-value="id"
                          label-value="nome"
                          :is-initial-open="true"
                          :items="centroCustos"
                          :initial-selecteds="user.centro_custos"
                          v-model="form.centro_custos"
                        ></check-group>
                        <jet-input-error
                          :message="form.errors.centro_custos"
                          class="mt-2"
                        />
                      </div>
                    </div>
                    <div class="grid grid-cols-12 py-2 gap-6">
                      <div class="col-span-12 sm:col-span-12">
                        <label class="block font-medium text-sm text-gray-700 mb-2">
                          Grupos
                        </label>
                        <check-group
                          id-value="id"
                          label-value="name"
                          :is-initial-open="true"
                          :items="roles"
                          :initial-selecteds="userRoles"
                          v-model="form.roles"
                        ></check-group>
                        <jet-input-error
                          :message="form.errors.roles"
                          class="mt-2"
                        />
                      </div>
                    </div>

                  </div>
                  <div class="flex items-center justify-end px-4  bg-gray-50 text-right sm:px-6">
                    <jet-action-message
                      :on="form.recentlySuccessful"
                      class="mr-3"
                    >
                      Salvo.
                    </jet-action-message>
                  </div>
                  <div class="flex flex-row-reverse space-x-4 space-x-reverse px-4 py-2 sm:py-6 bg-gray-50">
                    <button-primary
                      :class="{ 'opacity-25': form.processing }"
                      :disabled="form.processing"
                    > Atualizar
                    </button-primary>
                    <button-secondary>
                      Cancelar
                    </button-secondary>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout';
import JetActionMessage from '@/Jetstream/ActionMessage'
import JetButton from '@/Jetstream/Button'
import JetFormSection from '@/Jetstream/FormSection'
import JetInput from '@/Jetstream/Input'
import JetInputError from '@/Jetstream/InputError'
import JetLabel from '@/Jetstream/Label';
import AnoInput from '@/Components/AnoInput';
import ButtonPrimary from '@/Components/ButtonPrimary';
import ButtonSecondary from '@/Components/ButtonSecondary';
import CheckGroup from '@/Components/CheckGroup';

export default {
  name: 'UserEdit',
  components: {
    AppLayout,
    JetActionMessage,
    JetButton,
    JetFormSection,
    JetInput,
    JetInputError,
    JetLabel,
    AnoInput,
    ButtonPrimary,
    ButtonSecondary,
    CheckGroup
  },
  props: ['user', 'centroCustos', 'roles', 'userRoles'],
  data() {
    return {
      form: this.$inertia.form({
        '_method': 'PUT',
        ...this.user,
        roles: this.userRoles
      }, {
        resetOnSuccess: false,
      })
    }
  },
  methods: {
    save() {
      this.form.post(route('user.update', this.user.id), {
        preserveScroll: true
      });
    }
  }
}
</script>


<style scoped>
</style>
